import React, { Component } from "react";
import { bool, func, string } from "prop-types";
import Image from "pages/_components/Image";
import { isIOS } from "react-device-detect";

class EcheqCheckbox extends Component {
    static propTypes = {
        checked: bool,
        name: string,
        onChange: func,
        disabled: bool,
    };

    static defaultProps = {
        onChange: () => {},
        checked: false,
        name: "",
        disabled: false,
    };

    render() {
        const { checked, onChange, name, disabled } = this.props;

        return (
            <div className="c-control c-control--has-icon c-control--checkbox">
                <input
                    id={`checkbox_${name}`}
                    className={isIOS ? "c-control-input-ios" : "c-control-input"}
                    type="checkbox"
                    name={name}
                    checked={checked}
                    disabled={disabled}
                    onChange={() => onChange(!checked)}
                />
                <label className="c-control-label" htmlFor={`checkbox_${name}`}>
                    <div className="c-control-icons">
                        <div className="c-control-mark">
                            <Image src="images/check.svg" className="svg-icon svg-caret" />
                        </div>
                    </div>
                </label>
            </div>
        );
    }
}

export default EcheqCheckbox;
